export const REQUEST_BILLING_DETAILS = 'REQUEST_BILLING_DETAILS';
export const REQUEST_BILLING_DETAILS_FAILURE = 'REQUEST_BILLING_DETAILS_FAILURE';
export const REQUEST_BILLING_DETAILS_SUCCESS = 'REQUEST_BILLING_DETAILS_SUCCESS';

export const REQUEST_BILLING_ORDER_NUMBER_DETAILS = 'REQUEST_BILLING_ORDER_NUMBER_DETAILS';
export const REQUEST_BILLING_ORDER_NUMBER_DETAILS_FAILURE = 'REQUEST_BILLING_ORDER_NUMBER_DETAILS_FAILURE';
export const REQUEST_BILLING_ORDER_NUMBER_DETAILS_SUCCESS = 'REQUEST_BILLING_ORDER_NUMBER_DETAILS_SUCCESS';


export const REQUEST_BILLING_DETAIL = 'REQUEST_BILLING_DETAIL';
export const REQUEST_BILLING_DETAIL_FAILURE = 'REQUEST_BILLING_DETAIL_FAILURE';
export const REQUEST_BILLING_DETAIL_SUCCESS = 'REQUEST_BILLING_DETAIL_SUCCESS';

export const REQUEST_ADD_BILLING_DETAIL = 'REQUEST_ADD_BILLING_DETAIL';
export const REQUEST_ADD_BILLING_DETAIL_SUCCESS = 'REQUEST_ADD_BILLING_DETAIL_SUCCESS';
export const REQUEST_ADD_BILLING_DETAIL_FAILURE = 'REQUEST_ADD_BILLING_DETAIL_FAILURE';

export const REQUEST_DELETE_BILLING_DETAIL = 'REQUEST_DELETE_BILLING_DETAIL';
export const REQUEST_DELETE_BILLING_DETAIL_SUCCESS = 'REQUEST_DELETE_BILLING_DETAIL_SUCCESS';
export const REQUEST_DELETE_BILLING_DETAIL_FAILURE = 'REQUEST_DELETE_BILLING_DETAIL_FAILURE';